export default __webpack_public_path__ + "static/1-23cabf9cc894e38f9ccfcf758b7605ab.webp";